import { render } from "./DatePickerDate.vue?vue&type=template&id=5605208b"
import script from "./DatePickerDate.vue?vue&type=script&lang=js"
export * from "./DatePickerDate.vue?vue&type=script&lang=js"

import "./DatePickerDate.vue?vue&type=style&index=0&id=5605208b&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__